/**
 * Paleta semântica reutilizada dos indicadores do próprio sistema
 * (ver indicador-azul/amarelo/vermelho/verde no SCSS do dashboard).
 */
export const CORES_SEMANTICAS = {
    sucesso: '#16a34a',
    atencao: '#f59e0b',
    erro: '#dc2626',
    info: '#2563eb'
} as const;

// Ordem importa: negações e prefixos "in-" ficam em ERRO e são testados antes
// do termo positivo correspondente (ex.: "inativa" antes de "ativa",
// "não enviado" antes de "enviado").
const REGRAS: { cor: string; termos: string[] }[] = [
    {
        cor: CORES_SEMANTICAS.erro,
        termos: [
            'CANCELAD',
            'EXCLUID',
            'ATRASAD',
            'VENCID',
            'SEM PROTOCOLO',
            'SEM REUNIA',
            'INATIV',
            'EXTINT',
            'AFASTAD',
            'DEVEDOR',
            'INADIMPLENTE',
            'EM DEBITO',
            'COM DEBITO',
            'NAO ENVIAD',
            'NAO ASSIN',
            'NAO ACEIT',
            'AUSENTE',
            'REJEITAD',
            'REPROVAD'
        ]
    },
    {
        cor: CORES_SEMANTICAS.atencao,
        termos: ['REMARCAD', 'PENDENT', 'EM ELABORAC', 'AGUARDAND', 'A VENCER']
    },
    {
        cor: CORES_SEMANTICAS.sucesso,
        termos: ['REALIZAD', 'CONCLUID', 'FINALIZAD', 'NO PRAZO', 'EM DIA', 'COM PROTOCOLO', 'COM REUNIA', 'ATIVA', 'ATIVO', 'ADIMPLENTE', 'QUITAD', 'ENVIAD', 'PRESENTE', 'CONFIRMAD', 'ASSINOU', 'ASSINAD', 'ACEIT', 'APROVAD']
    },
    {
        cor: CORES_SEMANTICAS.info,
        termos: ['AGENDAD']
    }
];

function normalizar(texto: string): string {
    return texto
        .normalize('NFD')
        .replace(/\p{M}/gu, '')
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, ' ')
        .trim();
}

/**
 * Retorna a cor semântica quando a categoria representa um estado com
 * significado claro (sucesso/atenção/erro/neutro). Para categorias apenas
 * nominais (modalidade, UF, tipo de participação...) retorna null, deixando
 * o gráfico usar sua cor padrão (monocromática/azul).
 */
export function resolverCorSemantica(codigo?: string | null, descricao?: string | null): string | null {
    const texto = normalizar(`${codigo ?? ''} ${descricao ?? ''}`);
    if (!texto) {
        return null;
    }

    for (const regra of REGRAS) {
        if (regra.termos.some((termo) => texto.includes(termo))) {
            return regra.cor;
        }
    }

    return null;
}
